"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.underline = exports.subTitleExtraSmall = exports.formLabelSmall = exports.buttonTextExtraSmall = exports.bodySmall = exports.baseType = void 0;
var _color = require("../../styles/variables/_color");
var _font = require("../../styles/variables/_font");
const baseType = exports.baseType = {
  fontFamily: 'Centra No 2',
  fontStyle: 'normal',
  margin: 0,
  color: _color.colorTextPrimary,
  letterSpacing: _font.fontLetterSpacing0,
  fontWeight: _font.fontWeightMedium,
  display: 'flex',
  alignItems: 'center'
};
const bodySmall = exports.bodySmall = {
  ...baseType,
  fontSize: _font.fontSize12,
  fontWeight: _font.fontWeightBook,
  letterSpacing: _font.fontLetterSpacing4
};
const formLabelSmall = exports.formLabelSmall = {
  ...baseType,
  fontSize: _font.fontSize12
  // Removing the font height as its breaking the chart axis labels
};
const buttonTextExtraSmall = exports.buttonTextExtraSmall = {
  ...baseType,
  fontSize: _font.fontSize12,
  letterSpacing: _font.fontLetterSpacing1
  // Removing the font height as its breaking the chart axis labels
};
const underline = exports.underline = {
  textDecoration: 'underline'
};
const subTitleExtraSmall = exports.subTitleExtraSmall = {
  ...baseType,
  fontSize: _font.fontSize12,
  letterSpacing: _font.fontLetterSpacing0
  // Removing the font height as its breaking the chart axis labels
};